const ORDER_NUMBER_QUERY_PARAM = 'order_number'
const ORDER_TOKEN_QUERY_PARAM = 'token'
const ORDER_TOKEN_STORAGE_PREFIX = 'kustom_order_access_token_'

const inMemoryTokens = new Map<string, string>()

const saveOrderAccessToken = (orderNumber: string, token: string): void => {
  try {
    window.sessionStorage.setItem(`${ORDER_TOKEN_STORAGE_PREFIX}${orderNumber}`, token)
  } catch (error) {
    inMemoryTokens.set(orderNumber, token)
  }
}

export const readOrderAccessToken = (orderNumber: string): string | null => {
  try {
    return window.sessionStorage.getItem(`${ORDER_TOKEN_STORAGE_PREFIX}${orderNumber}`) || inMemoryTokens.get(orderNumber) || null
  } catch (error) {
    return inMemoryTokens.get(orderNumber) || null
  }
}

export const stripOrderAccessTokenFromLocation = (): void => {
  if (typeof window === 'undefined') {
    return
  }

  const url = new URL(window.location.href)
  const token = url.searchParams.get(ORDER_TOKEN_QUERY_PARAM)
  const orderNumber = url.searchParams.get(ORDER_NUMBER_QUERY_PARAM)

  if (!token || !orderNumber) {
    return
  }

  saveOrderAccessToken(orderNumber, token)
  url.searchParams.delete(ORDER_TOKEN_QUERY_PARAM)
  window.history.replaceState(window.history.state, '', url.toString())
}

export const stashOrderAccessToken = (to, next): void => {
  const { [ORDER_TOKEN_QUERY_PARAM]: token, ...query } = to.query || {}
  const orderNumber = query[ORDER_NUMBER_QUERY_PARAM]

  if (typeof window === 'undefined' || typeof token !== 'string' || typeof orderNumber !== 'string') {
    next()
    return
  }

  saveOrderAccessToken(orderNumber, token)
  next({ path: to.path, query, hash: to.hash, replace: true })
}
